import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Hero from './components/Hero/Hero'
import Feature from './components/Features/Features'
import Section from './components/UI/Section'
import SocialMedia from './components/SocialMedia/SocialMedia'
import Gallery from './components/Gallery/Gallery'
import Footer from './components/Footer/Footer'
import VideoSection from './components/UI/VideoSection'
import BlogLayout from './components/Blog/BlogLayout'
import BlogList from './components/Blog/BlogList'
import BlogPost from './components/Blog/BlogPost'
import BlogPreview from './components/Blog/BlogPreview'
import Changelog from './components/Changelog'
import Beta from './components/Beta/Beta'
import ToS from './components/ToS/ToS'

const AnalyticsListener: React.FC = () => {
	const location = useLocation()

	useEffect(() => {
		// Ensure gtag is available before calling
		const gtag = (window as any).gtag as undefined | ((...args: unknown[]) => void)
		if (!gtag) {
			return
		}

		gtag('config', 'G-0KLHCT3ZZB', {
			page_path: location.pathname + location.search,
			page_title: document.title,
		})
	}, [location.pathname, location.search])

	return null
}

const HomePage: React.FC = () => {
	return (
		<>
			<Hero />
			<Section
				backgroundImage="city_ruins.gif"
				sectionId="blog"
			>
				<BlogPreview />
			</Section>
			<Section
				backgroundImage="city_ruins.gif"
				// gradientBackground="linear-gradient(to bottom, #000000, #700000"
				sectionId="features"
			>
				<Feature />
			</Section>
			<VideoSection
				backgroundImage="back_mute.webm"
				// gradientBackground="linear-gradient(to bottom, #000000, #700000"
				sectionId="social-media"
			>
				<SocialMedia />
			</VideoSection>
			<Section
				backgroundImage="city_ruins.gif"
				// gradientBackground="linear-gradient(to bottom, #000000, #700000"
				sectionId="gallery"
			>
				<Gallery />
			</Section>
			<Footer />
		</>
	)
}

const App: React.FC = () => {
	return (
		<Router>
			<div className="min-h-screen bg-gray-900">
				<Header />
				<AnalyticsListener />
				<Routes>
					<Route path="/" element={<HomePage />} />
					<Route path="/blog" element={<BlogLayout />}>
						<Route index element={<BlogList />} />
						<Route path=":id" element={<BlogPost />} />
					</Route>
					<Route path="/changelog" element={<Changelog />} />
					<Route path="/beta" element={<Beta />} />
					<Route path="/tos" element={<ToS />} />
				</Routes>
			</div>
		</Router>
	)
}

export default App
